import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/app-redux/hooks";
import { getAllGateDocuments } from "src/app-redux/vehicle/actions/vehicleActions";
import { selectVehicleDetails } from "src/app-redux/vehicle/vehicleSlice";
import { colorCodeListForGateIn, customColorCodeList } from "src/common/utils/app.dropdowns";
import { useStyles } from "./style";
import IconButton from "@mui/material/IconButton";
import img from "src/assets/images/file_formats_logos/img.svg";
import doc from "src/assets/images/file_formats_logos/doc.svg";
import pdf from "src/assets/images/file_formats_logos/pdf.svg";
import xlsx from "src/assets/images/file_formats_logos/xlsx.svg";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { downloadFile } from "src/app-redux/common-actions";

export interface IDrawerDetailsProps {}

export default function DrawerDetails(props: IDrawerDetailsProps) {
  const classes = useStyles();
  // Redux
  const vehicleDetailsResponse: any = useAppSelector(selectVehicleDetails);
  const dispatch = useDispatch();
  const [allDocs, setAllDocs] = useState<any[]>([]);

  useEffect(() => {
    if (Boolean(vehicleDetailsResponse.vehicleDetail)) getPictureGalleryContent();
  }, [vehicleDetailsResponse]);

  const getPictureGalleryContent = async () => {
    const res: any = await dispatch(
      getAllGateDocuments({ gatePassId: vehicleDetailsResponse.vehicleDetail.gateEntryId })
    );
    if (res.payload) setAllDocs(res.payload);
  };

  const downloadDocument = async (item: any) => {
    const type =
      item.fileCategory === "Scan"
        ? 2
        : item.fileCategory === "Weight"
        ? 3
        : item.fileCategory === "Commercial"
        ? 4
        : 1;
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=${type}`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  const remarks = (remarks: any) => {
    const remarksArray = remarks.split("@``@");

    const notesElements = remarksArray?.map((value: any, index: number) => (
      <>
        <div key={index}>{value ? value : ""}</div>
        {index !== remarksArray.length - 1 && remarksArray[0].length > 1 && <br />}
      </>
    ));

    return notesElements;
  };

  return (
    <div className={classes.drawerDetails}>
      {/* Vehicle Details */}
      <Typography className="heading">Vehicle Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Vehicle Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleRegNumber
                ? vehicleDetailsResponse.vehicleDetail?.vehicleRegNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Vehicle Status</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleStatus
                ? vehicleDetailsResponse.vehicleDetail?.vehicleStatus
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Vehicle Type</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleType
                ? vehicleDetailsResponse.vehicleDetail?.vehicleType
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Location at Terminal</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.terminalLocation
                ? vehicleDetailsResponse.vehicleDetail?.terminalLocation
                : "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Gate Entry Opperator</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.entryBy
                ? vehicleDetailsResponse.vehicleDetail?.entryBy
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Slip Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.slipNumber
                ? vehicleDetailsResponse.vehicleDetail?.slipNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Commercial</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.commercial ? "Yes" : "No"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Chassis Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleChassisNumber
                ? vehicleDetailsResponse.vehicleDetail?.vehicleChassisNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Vehicle Color</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleColor
                ? vehicleDetailsResponse.vehicleDetail?.vehicleColor
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Vehicle Brand</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleBrand
                ? vehicleDetailsResponse.vehicleDetail?.vehicleBrand
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Vehicle Model</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleModel
                ? vehicleDetailsResponse.vehicleDetail?.vehicleModel
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Vehicle Make/Year</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleMake
                ? vehicleDetailsResponse.vehicleDetail?.vehicleMake
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Vehicle Channel</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleColorCode
                ? colorCodeListForGateIn.find(
                    (val: any) => val.value == vehicleDetailsResponse.vehicleDetail.vehicleColorCode
                  )?.name
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Agent Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.agentName
                ? vehicleDetailsResponse.vehicleDetail?.agentName
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Agent’s Mobile Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.agentMobileNumber
                ? vehicleDetailsResponse.vehicleDetail?.agentMobileNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">WeBOC RMS Color Code</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.vehicleCustomColorCode
                ? customColorCodeList.find(
                    (val: any) =>
                      val.value === vehicleDetailsResponse.vehicleDetail.vehicleCustomColorCode
                  )?.name
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Yard Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.allotedYardDetails?.yardName
                ? vehicleDetailsResponse.allotedYardDetails?.yardName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Yard Row Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.allotedYardDetails?.rowName
                ? vehicleDetailsResponse.allotedYardDetails?.rowName
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Yard Row Slot</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.allotedYardDetails?.slotNumber
                ? vehicleDetailsResponse.allotedYardDetails?.slotNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">CRM Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.crmNumber
                ? vehicleDetailsResponse.vehicleDetail?.crmNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">E-Form Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.eFormNumber
                ? vehicleDetailsResponse.vehicleDetail?.eFormNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Pass Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.passNumber
                ? vehicleDetailsResponse.vehicleDetail?.passNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Driver Details */}
      <Typography className="heading">Driver Details </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Driver Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverName
                ? vehicleDetailsResponse.vehicleDetail?.driverName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Driver’s Father Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverFatherName
                ? vehicleDetailsResponse.vehicleDetail?.driverFatherName
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Driver’s Mobile Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverMobileNumber
                ? vehicleDetailsResponse.vehicleDetail?.driverMobileNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Driver’s CNIC</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverCNIC
                ? vehicleDetailsResponse.vehicleDetail?.driverCNIC
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Travelling Doc Type</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.travellingDocType
                ? vehicleDetailsResponse.vehicleDetail?.travellingDocType
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Travelling Doc Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.travellingDocNumber
                ? vehicleDetailsResponse.vehicleDetail?.travellingDocNumber
                : "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">NTN</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverNTN
                ? vehicleDetailsResponse.vehicleDetail?.driverNTN
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Resident</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.driverResident
                ? vehicleDetailsResponse.vehicleDetail?.driverResident
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Cargo Information */}
      <Typography className="heading">Cargo Information </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Type Of Consignment</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.consignmentTypeName
                ? vehicleDetailsResponse.vehicleDetail?.consignmentTypeName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Type Of Cargo</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.cargoTypeName
                ? vehicleDetailsResponse.vehicleDetail?.cargoTypeName
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Container Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.containerNumber
                ? vehicleDetailsResponse.vehicleDetail?.containerNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Container Seal Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.sealNo
                ? vehicleDetailsResponse.vehicleDetail?.sealNo
                : "-"}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Good’s Declaration Number (GD#)</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gdNo
                ? vehicleDetailsResponse.vehicleDetail?.gdNo
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">GD Date</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gdDate
                ? moment(new Date(vehicleDetailsResponse.vehicleDetail?.gdDate)).format(
                    "DD-MM-YYYY"
                  )
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Supplier Name</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.supplierName
                ? vehicleDetailsResponse.vehicleDetail?.supplierName
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">WeBOC ID (IGM#)</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.webBocId
                ? vehicleDetailsResponse.vehicleDetail?.webBocId
                : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Others */}
      <Typography className="heading">Others </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Entry Date and Time</Typography>
            <Typography className="subHeadingDetails">
              {moment(new Date(vehicleDetailsResponse.vehicleDetail?.dateTime)).format(
                "DD-MM-YYYY hh:mm A"
              )}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.notes ? (
                <>{remarks(vehicleDetailsResponse.vehicleDetail?.notes)} </>
              ) : (
                "-"
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">Customs Inspector Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.remarks
                ? vehicleDetailsResponse.vehicleDetail?.remarks
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Typography className="subHeading">Gate-out Remarks</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.gateOutComments
                ? vehicleDetailsResponse.vehicleDetail?.gateOutComments
                : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" className="itemRow">
          <Grid item md={1}></Grid>
          <Grid item md={6}>
            <Typography className="subHeading">WeBOC Vehicle Number</Typography>
            <Typography className="subHeadingDetails">
              {vehicleDetailsResponse.vehicleDetail?.webocVehicleNumber
                ? vehicleDetailsResponse.vehicleDetail?.webocVehicleNumber
                : "-"}
            </Typography>
          </Grid>
          <Grid item md={5}></Grid>
        </Grid>
      </Grid>

      {/* Picture Gallery */}
      <Typography className="heading">All Documents </Typography>
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow" spacing={2}>
          <Grid
            item
            md={12}
            id="main-div"
            className={classes.drawerDetails}
            style={{
              height: "max-content",
            }}
          >
            <Grid container direction="row">
              {/* History Item  */}
              {allDocs.length !== 0 ? (
                allDocs.map((item: any) => (
                  <Grid md={6} key={item.id} style={{ padding: "5px" }}>
                    <Grid container direction="row" className="itemRowTrail">
                      <Grid md={3} style={{ padding: "5px" }}>
                        <img
                          src={
                            item.extension === "doc" || item.extension === "docx"
                              ? doc
                              : item.extension === "jpg" ||
                                item.extension === "jpeg" ||
                                item.extension === "png"
                              ? img
                              : item.extension === "pdf"
                              ? pdf
                              : item.extension === "xlsx"
                              ? xlsx
                              : img
                          }
                          alt={item.extension}
                          width="25px"
                        />
                      </Grid>
                      <Grid md={6}>
                        <Typography className="subHeading itemName">
                          {item.originalFileName}
                        </Typography>
                      </Grid>
                      <Grid md={2}>
                        <IconButton
                          onClick={() => {
                            downloadDocument(item);
                          }}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ))
              ) : (
                <div></div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
